// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1211":"67393158117540e3","2888":"c751c132549bfea8","3439":"691cb9ea5be8a2d3"}[chunkId] + ".css";
};